import React, { useState } from 'react'
import TransitionalModal from "../components/transitional";
import AddHomeWorkIcon from '@mui/icons-material/AddHomeWork';
import { BURL } from '../../../services/base';
// Image
import SmallLoader from '../../widgets/SmallLoader';
import useAPI from '../../../hooks/useAPI';
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Slide, Snackbar } from '@mui/material';

import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { Link, useParams } from 'react-router-dom';
import TenantHorizontalLinearStepper from '../components/tenantLinearStepper';
import axios from 'axios';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});

function Tenancy() {
    const [loading, setLoading] = React.useState(false);
    const [confirmLoading, setConfirmLoading] = React.useState(false);
    const [showModal, setShowModal] = React.useState(false);
    const [errorText, setErrorText] = React.useState(null);
    const [success, setSuccess] = React.useState(null);
    const [properties, setProperties] = React.useState([]);
    const [tenants, setTenants] = React.useState([]);
    const [tenantsUnit, setTenantsUnit] = React.useState([]);
    const [confirmationOpen, setConfirmationOpen] = React.useState(false);
    const [tenantRoomId, setTenantRoomId] = React.useState(false);

    const { unitId, id } = useParams();

    const { deleteRequest } = useAPI();
    const [state, setState] = React.useState({
        opened: false,
        vertical: 'top',
        horizontal: 'center',
    });
    const { vertical, horizontal, opened } = state;

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toISOString().split('T')[0]; // Formats as yyyy-mm-dd
    };

    const getTenantsByUnitRoom = React.useCallback(async () => {
        const token = localStorage.getItem('token');
        setLoading(true);
        setErrorText(null);
        const response = await axios.get(`${BURL}/admin/properties/units/${unitId}/rooms`, {
            params: {
                withProperty: false,
                withUnit: true,
                withTenants: true
            },
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        setLoading(false);
        if (response?.status) {
            const res = await response.data.data;
            const result = res.find(item => item.id == id);

            if (result) {
                setTenantsUnit(result.unit);
                setTenants(result.tenants || []);
            } else {
                setTenants([]);
            }
        } else {
            setTenants([]); // also handle this case
            // setErrorText(response.message ?? 'Request Error');
        }

    }, [unitId, id])

    React.useEffect(() => {
        getTenantsByUnitRoom();
    }, [getTenantsByUnitRoom])

    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleConfirmation = (roomId) => {
        setConfirmationOpen(true);
        setTenantRoomId(roomId)
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleSnackbarClose = (
        event,
        reason
    ) => {
        if (reason === 'clickaway') {
            return;
        }
        setState({ ...state, open: false });
    };


    const handleClickOpen = () => {
        setShowModal(true);
    };

    const removeTenant = (newState) => async (propertyId) => {
        const token = localStorage.getItem('token');
        setConfirmLoading(true);
        setErrorText(null);

        try {
            const url = `${BURL}/admin/tenant-room`;
            const body = { propertyId, tenantRoomId };
            const response = await deleteRequest(url, body, token);
            setSuccess(response.message);
            if (response?.status) {
                setSuccess(response.message)
                getTenantsByUnitRoom();
            } else {
                setErrorText(response.message);
            }
        } catch (err) {
            // setErrorText(err);
            setErrorText(err?.response?.data?.message || err.message || 'Something went wrong');
        } finally {
            setLoading(false);
            setConfirmationOpen(false);
        }
    };

    const loader = <SmallLoader />
    return (
        <>
            <div className="px-5 md:px-10 sm:px-3 flex flex-col gap-10 mt-5 md:mt-4 pt-3 mb-0 overflow-x-hidden">
                <div className='w-full text-[#6C6C6C] flex justify-between'>
                    <div className='flex gap-3'>
                        <Link to={'/dashboard/properties'} className='hidden sm:flex font-[600] text-[18px] md:text-[22px] cursor-pointer'>Properties</Link>
                        <Link to={`/dashboard/properties/${tenantsUnit.propertyId}`} className='hidden sm:flex mt-3 text-[12px] md:text-[14px] cursor-pointer'> > Property Details > </Link>
                        <Link to={`/dashboard/property/${tenantsUnit.propertyId}/unit/${tenantsUnit.id}`} className='mt-3 text-[12px] md:text-[14px] cursor-pointer'> {tenantsUnit.name}</Link>
                        <span className='mt-3 text-[12px] md:text-[14px]'> > Room</span>
                    </div>
                </div>
            </div>
            <div className="md:px-10 sm:px-3 mt-5 md:mt-4 flex justify-end items-center pt-3 bg-white mb-0">
                <button className='px-5 py-2 bg-austel-green hover:bg-[#0d964d] hover:font-semibold flex items-center gap-2 !rounded-full text-white transition-all ease-in duration-500' onClick={handleClickOpen}> <AddHomeWorkIcon className='text-white' /> <p className='flex font-semibold text-[12px] md:text-[14px] items-center py-auto mt-2'>Add Tenant</p>
                </button>
            </div>
            <Dialog
                open={showModal}
                TransitionComponent={Transition}
                keepMounted
                onClose={() => setShowModal(false)}
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description">
                        <TenantHorizontalLinearStepper open={showModal} setOpen={setShowModal} currentPropertyId={tenantsUnit.propertyId} currentUnitId={tenantsUnit.id} currentRoomId={id}  />
                    </DialogContentText>
                </DialogContent>
            </Dialog>
            <div className='w-auto bg-white overflow-x-hidden'>
                {/* Property section */}
                <div className="px-[1.22rem] md:px-12 bg-white overflow-x-hidden">
                    <p className='mb-[3rem] xl:mb-[5rem] font-semibold text-sm text-austel-green'>Tenant(s) Details</p>
                    {loading && <SmallLoader />}
                    {(errorText && !loading) && errorText}
                    {!errorText && !loading && tenants && tenants.length == 0 && <div className='mt-24 flex gap-5 lg:mx-0 justify-center text-center'>{(!errorText && !loading && tenants && tenants.length === 0)
                        && 'There is currently no tenant. Click CREATE TENANT to add a tenant to a property.'}
                    </div>}
                    {errorText && <Button onClick={getTenantsByUnitRoom}>Try again</Button>}
                    {Array.isArray(tenants) && tenants.length !== 0 &&
                        <div className='overflow-x-auto my-table w-[100%] lg:w-[99%] xl:w-full'>
                            <table className='table-auto w-full text-[#6C6C6C]'>
                                <thead>
                                    <th>Room No</th>
                                    <th>Name</th>
                                    <th>Email</th>
                                    <th>Check In</th>
                                    <th>Check Out</th>
                                    <th>Action</th>
                                </thead>
                                <tbody>
                                    {tenants.map((tenant, index) =>
                                        <tr key={tenant.id || index} className='mb-[30rem]'>
                                            <td>{tenant?.tenantRoom?.tenantRoomId}</td>
                                            <td className='capitalize'>{tenant.user.firstname} {tenant.user.lastname}</td>
                                            <td>{tenant.user.email}</td>
                                            <td>{formatDate(tenant?.tenantRoom?.checkIn)}</td>
                                            <td>{formatDate(tenant?.tenantRoom?.checkOut)}</td>
                                            <td className='flex gap-4 items-center'>
                                                <span title='Delete room' className='cursor-pointer'>
                                                    <DeleteIcon className='flex items-center cursor-pointer text-red-600' sx={{ fontSize: '18px' }} onClick={() => handleConfirmation(tenant?.tenantRoom?.tenantRoomId)} />
                                                </span>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    }

                </div>
            </div>
            <Dialog
                open={confirmationOpen}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"Remove tenant from room?"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to remove this tenant?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setConfirmationOpen(false)}>No</Button>
                    <Button sx={{ color: 'red' }} onClick={() => removeTenant({ vertical: 'bottom', horizontal: 'right' })(tenantsUnit.propertyId)} autoFocus className='text-[#BD2424]'>
                        {!confirmLoading && <span>Yes</span>}

                        {confirmLoading && loader}
                    </Button>
                </DialogActions>
            </Dialog>
            {/* <div className="md:px-10 sm:px-3 flex justify-between items-center py-3 border-b-2 bg-white">
                <h1 className="font-bold">  Properties</h1>
            </div> */}
            {success && <Snackbar open={open} autoHideDuration={6000} onClose={handleSnackbarClose} anchorOrigin={{ vertical, horizontal }}
                key={vertical + horizontal}>
                <Alert
                    onClose={handleSnackbarClose}
                    severity="success"
                    variant="filled"
                    sx={{ width: '100%' }}
                >
                    {success}
                </Alert>
            </Snackbar>}
            {errorText && <Snackbar open={open} autoHideDuration={6000} onClose={handleSnackbarClose} anchorOrigin={{ vertical, horizontal }}
                key={vertical + horizontal}>
                <Alert
                    onClose={handleSnackbarClose}
                    severity="error"
                    variant="filled"
                    sx={{ width: '100%' }}
                >
                    {errorText}
                </Alert>
            </Snackbar>}
        </>
    )
}

export default Tenancy